// extracted by mini-css-extract-plugin
module.exports = {"container":"DrugManufacturerWidget_container__2w8mK","without-web":"DrugManufacturerWidget_without-web__d58Nj","content":"DrugManufacturerWidget_content__LwJVa"};